export const spinnerDefaultProps = {
    size: 'medium',
    color: '--color-secondary-100',
};
